export function mask(value, max) {
    value = String(value);
    value = value.replace(/[^0-9.]*/g, ''); //Elimina caracteres y solo deja numeros y puntos;
    if(value !== "0"){
        value = value.replace(/^0+/, ''); // Elimina ceros al principio de la cadena;
    }
    value = value.replace(/^\.+/, ''); // Elimina puntos al principio de la cadena;
    
    // validacion de cantidad maxima permitida
    let valueFloat = parseFloat(value);
    
    let parts = value.toString().split("."); // seccciona la cadena en arrays cada que encuentra un punto

    parts[0] = parts[0].replace(/,/g, ''); // en la primer parte de la cadena elimina las comas.

    if(parts.length >= 2){
        if(max != 0 && valueFloat > max) {
            let lastDigitIntegerPart =  parts[0].substring(parts[0].length - 1);
            parts[0] =  parts[0].substring(0, parts[0].length - 1);
            parts[1] =  parts[1].substring(0, parts[1].length - 1);
            parts[1] = lastDigitIntegerPart + parts[1];
        }
        let partDecimal = parts[1].replace(/,/g, ''); // en la segunda parte de la cadena elimina las comas.
        if(partDecimal == ""){
            partDecimal = partDecimal;
        } else {
            partDecimal = partDecimal.substr(0, 2);
        }
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); //Pone una coma cada 3 digitos en la primer parte de la cadena
        value = parts[0] +"."+ partDecimal;
    } else {
        if(max != 0 && valueFloat > max) {
            let totalDigitsSubstr = (valueFloat/max-1).toString().split(".");
            parts[0] = parts[0].substring(0, parts[0].length - totalDigitsSubstr[0].length);
        }
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); //Pone una coma cada 3 digitos en la primer parte de la cadena
        value = parts[0];
    }
    value = (value === "")?"0":value;
    return {
        value: value,
        maskedValue: value
    };
}
